import React, { Component } from 'react'
// import MenuComponent from './MenuComponent';
import Translate from 'react-translate-component';
import couterpart from 'counterpart';

import AuthenticationService from '../services/AuthenticationService';
import WhitelistService from '../services/WhiteListService';
import '../css/style.css';
import {IoIosLogIn} from 'react-icons/io';
import { ICON_COLOR } from '../icon';

class LoginComponent extends Component {

    constructor(props) {
        super(props)

        this.state = {
            username: '',
            password: '',
            macAddress: ''
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentDidMount () {
        //TODO: Open this
        // AuthenticationService.getMacAddress().then(data => {
        //     this.setState({ macAddress:  data})
        // })
    }

    handleChange(event) {
        this.setState(
            {
                [event.target.name]
                    : event.target.value
            }
        )
    }

    handleSubmit() {
        try {
            AuthenticationService.executeBasicAuthenticationService(this.state.username,this.state.password, this.state.macAddress)      
            .then(({ token, roles, username, userId, workingShop, limitUser, department, bcprint, dcprint }) => {
                if (token !== undefined){
                    console.log(token);
                    console.log(roles);
                    console.log(username);
                    console.log(workingShop);
                    console.log(limitUser);
                    console.log(department);
                    console.log(bcprint);
                    console.log(dcprint);
                    AuthenticationService.registerSuccessfulLogin(token, roles, username, userId, workingShop, limitUser, department, bcprint, dcprint);
                    if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isDesigner()){
                        this.props.history.push("/");
                    } else if (AuthenticationService.isShipping()) {
                        this.props.history.push("/shipOrders");
                    } else if (AuthenticationService.isKhac()) {
                        this.props.history.push("/");
                    } else if (AuthenticationService.isKim()) {
                        this.props.history.push("/kimScan");
                    } else if (AuthenticationService.isWorker()) {
                        this.props.history.push("/LenScan");
                    } else{
                        this.props.history.push("/");
                    }
                }else{
                    alert("Invalid username and password!");
                }
            }).catch(function(error) {
                alert("Cannot Login to system.");
            });
        } catch (e) {
            alert(e.message);
        }
    }

    doSettings() {
        try {
            AuthenticationService.executeBasicAuthenticationService("super_admin", this.state.password)      
            .then(({ token, roles, username, userId }) => {
                if (token !== undefined){
                    localStorage.setItem("test", this.state.macAddress);
                    this.props.history.push("/");
                }else{
                    alert("Unauthorized");
                }
            }).catch(function(error) {
                alert("Unauthorized");
            });
        } catch (e) {
            alert(e.message);
        }
    }

    handleKeyDown(e){
        if (e.key === 'Enter') {
            this.handleSubmit()
        }
    }    

    render() {
        return (
            <div className="auth-wrapper">
                <div className="auth-inner">            
                    <form>
                        <h3><Translate content="button_login"/></h3>
                        <div className="form-group">
                            <label><Translate content="user_name"/></label>
                            <input type="email" name="username" className="form-control" 
                            placeholder={couterpart.translate("user_name")}
                            onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className="form-group">
                            <label><Translate content="password"/></label>
                            <input type="password" name="password" className="form-control" 
                                placeholder={couterpart.translate("password")} 
                                onChange={this.handleChange.bind(this)} onKeyDown={ this.handleKeyDown.bind(this) } />
                        </div>
                        <button type="button" className="btn btn-primary btn-block myButton2" 
                            onClick={this.handleSubmit.bind(this)}><IoIosLogIn color={ICON_COLOR}/>
                                &nbsp;<Translate content="button_login"/>
                        </button>
                    </form>  
                </div>
            </div>           
        )
    }
}

export default LoginComponent